export default {
  getRowAvailable(row) {
    return {};
  },

  getSectionAvailable(section) {
    return true;
  },

  getWeight(separate, capacity, thrusters) {
    return {
      rack_kit_weight: 0,
      tier_shelf_weight: 0,
    };
  },

  getRowItems(data, row) {
    if (row.sections.length === 0)
      return {};

    const items = [];

    function addItem(type, item, quantity = 1) {
      if (!item || quantity == 0)
        return;

      const existItem = items.find((existItem) => existItem.id === item.id);

      if (existItem) {
        existItem.quantity += quantity;
      } else {
        items.push({
          type,
          id: item.id,
          name: item.name,
          price: item.price,
          quantity,
        });
      }
    }

    row.sections.forEach(section => {
      const rack_kit = data.rack_kit.find(rack_kit => {
        return (rack_kit.height == row.height);
      });
      addItem('rack_kit', rack_kit, 4);

      const cross_beam = data.cross_beam.find(cross_beam => {
        return (cross_beam.depth == row.depth);
      });
      addItem('cross_beam', cross_beam, section.count * 2);

      const longitudinal_beam = data.longitudinal_beam.find(longitudinal_beam => {
        return (longitudinal_beam.length == section.width);
      });
      addItem('longitudinal_beam', longitudinal_beam, section.count * 2);

      if (section.type === 'plywood') {
        const tier_flooring = data.tier_flooring.find(tier_flooring => {
          return (tier_flooring.depth == row.depth && tier_flooring.length == section.width);
        });
        addItem('tier_flooring', tier_flooring, section.count);
      } else if (section.type === 'metal') {
        const tier_shelf = data.tier_shelf.find(tier_shelf => {
          return (tier_shelf.depth == row.depth);
        });
        addItem('tier_shelf', tier_shelf, section.count * Math.floor(section.width / tier_shelf.length));
      }

      if (section.coupler) {
        const beam_coupler = data.beam_coupler.find(beam_coupler => {
          return (beam_coupler.depth == row.depth);
        });
        addItem('beam_coupler', beam_coupler, section.count);
      }
    });

    return {
      items,
      price: items.reduce((a, c) => a + c.price * c.quantity, 0).toFixed(2),
    };
  }
};
